export const FETCH_BONUSES_AND_FREEBETS_INIT = 'FETCH_BONUSES_AND_FREEBETS_INIT';
export const FETCH_BONUSES_AND_FREEBETS_SUCCESS = 'FETCH_BONUSES_AND_FREEBETS_SUCCESS';
export const FETCH_BONUSES_AND_FREEBETS_FAIL = 'FETCH_BONUSES_AND_FREEBETS_FAIL';

export const FETCH_BONUSES_SUCCESS = 'FETCH_BONUSES_SUCCESS';
export const FETCH_BONUSES_FAIL = 'FETCH_BONUSES_FAIL';

export const HIDE_FREEBET = 'HIDE_FREEBET';
